// extracted by mini-css-extract-plugin
module.exports = {"okBtn":"app-errors-dialog_okBtn_3UaRm","errorsMessages":"app-errors-dialog_errorsMessages_2Z4V0"};